export const ITEM_TYPE_PHOTO = 0;
export const ITEM_TYPE_VIDEO = 1;